import { createAction, props } from '@ngrx/store';
import { PermissionModel } from '@shared/data-access/models';

export const getDetail = createAction('[User Permission] GET DETAIL', props<{ item: PermissionModel }>());
